import React from 'react';
import {
    NavLink,
    Redirect,
    Route,
    Switch
} from 'react-router-dom';
import { connect } from 'react-redux';

import Nav from './../components/Nav';
import classNames from './../utils/classNames';

import InboxSupportPage from './InboxSupportPage';
import InboxUpdatesPage from './InboxUpdatesPage';
import InboxUpdatesDetailPage from './InboxUpdatesDetailPage';
import {getHasUnreadInboxItems} from './../store/notification/selectors'


const InboxPage = props => {
    const { match, hasNewInboxItems } = props
    const updateClassName = classNames({new: hasNewInboxItems})
    return (
        <div>
            <Nav sub>
                {/* <NavLink to={`${match.url}/support`}>Support</NavLink> */}
                <NavLink className={updateClassName} to={`${match.url}/updates`}>Updates</NavLink>
            </Nav>
            <Switch>
                <Route path={`${match.url}/support`} component={InboxSupportPage} />
                <Route path={`${match.url}/updates/:id`} component={InboxUpdatesDetailPage} />
                <Route path={`${match.url}/updates`} component={InboxUpdatesPage} />
                <Redirect from={match.url} exact to={{ pathname: `${match.url}/updates`, search: window.location.search }} push={false} />
            </Switch>
        </div>
    );
};


const mapStateToProps = state => {
    const hasNewInboxItems = getHasUnreadInboxItems(state)
    return { hasNewInboxItems }
};

const mapDispatchToProps = dispatch => { return {} };

export default connect(mapStateToProps, mapDispatchToProps)(InboxPage);


// WEBPACK FOOTER //
// ./src/pages/InboxPage.js